<template lang="pug">
v-col(cols='2')
    v-toolbar-items
        v-icon.mx-3(v-if='icon') {{ icon }}
        h4.pt-2 {{ title }}
    h1.mr-2.text-right
        slot
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: undefined,
        },
    },
});
</script>
